import React, { useState, useEffect } from 'react';
import useStyles from './TaskRealm.styles';
import { get, size, last, set } from 'global/lib/lodash';
import useRetrieveData from 'global/hooks/useRetrieveData';
import TaskListItem from '../TaskList/TaskListItem';
import { useDispatch, useSelector } from 'react-redux';
import { List, ListItem, ListItemText, Icon, IconButton, ListItemSecondaryAction, Button } from '@material-ui/core';
import Image from 'material-ui-image';
import { CenterContent, LeftSideBar, RightSideBar, GridContainer } from 'global/components/perform-grid';
import { getTaskStatus, getTaskImage, getUrlParams } from 'global/utils';
import { Link, useLocation } from 'react-router-dom';
import TaskCreate from '../TaskCreate';
import TaskNotify from '../TaskNotify';
import moment from 'moment';
import TaskFilters from '../Filters';
import { buildFilters } from 'global/utils/filter';
import withInfiniteScroll from 'global/components/withInfiniteScroll';
import MessageListItem from '../TaskList/MessageListItem';
import { Loading } from 'global/styles';
import { setTaskList, removeNewTask, addNewTask } from 'redux/actions/view';
import realmChange from 'global/wrappers/realmChange';
import { useVendors } from 'global/hooks/useVendors';
import ScoreIcon from 'global/components/ScoreIcon';
import { CondenseIcon } from 'global/components/PerformIcons';
import { userHasPermissions } from 'redux/actions/userLogin';
import { useScreen } from 'global/styles';
import { ImageList } from 'global/components/image';
import { RenderTag } from '../TaskCreate/TaskCreate';
import clsx from 'clsx';
import { uppercaseFirst } from 'global/utils';

const include =
  'images,assessment,realm,authors,assignees,viewers,comments,scorecardScore,scorecardScore.checklist,scorecardScore.checkpoint,scorecardScore.checkpoint.checkpointOptions,subScore,subScore.scorecardScore';
const pageSize = 25;

const getCommentText = (task) => {
  const commCount = size(task.comments);
  if (commCount > 0) {
    const lastComm = last(task.comments);
    const time = moment(lastComm.updatedAt).fromNow();
    return `${commCount} comment${commCount > 1 ? 's' : ''} - ${time}`;
  } else {
    return 'No comments';
  }
};

const TaskItem = (props) => {
  const classes = useStyles();
  const { item, showChecks, expanded, tcid } = props;
  const task = item;
  const [tag, setTag] = useState();
  const status = getTaskStatus(task);
  const image = getTaskImage(task);
  const commText = getCommentText(task);
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const dispatch = useDispatch();
  const isSelected = newTasks.find((t) => t.id === task.id);
  const [modalOpen, setModalOpen] = useState(false);

  const onIconClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSelected) {
      dispatch(removeNewTask(task));
    } else {
      dispatch(addNewTask({ ...task, fromSelected: true }));
    }
  };

  const renderIcon = () => (
    <div className={classes.leftIconWrap}>
      <IconButton onClick={onIconClick}>{showChecks ? <ScoreIcon useBlankCheckbox={!isSelected} selected={isSelected} /> : <Icon>{status.icon}</Icon>}</IconButton>
    </div>
  );

  const d = item;

  const scorecardId = expanded ? get(d, 'scorecardScore.scorecardId', get(d, 'subScore.scorecardScore.scorecardId', null)) : null;
  const scData = useRetrieveData(
    { url: `/scorecards/${scorecardId}` },
    {
      waitFor: scorecardId,
      build: ['scorecards'],
    }
  );
  const scorecard = get(scData, 'data.0');
  const scorecardConfig = get(scData, 'data.0.config');

  useEffect(() => {
    if (d) {
      if (get(d, 'scorecardScore')) {
        const scs = get(d, 'scorecardScore');
        const cp = get(scs, 'checkpoint');

        setTag({
          scorecardConfig: scorecardConfig,
          ...cp,
          ...scs,
        });
      } else if (get(d, 'subScore')) {
        const { subScore, ...rest } = d;
        setTag({
          ...rest,
          scorecardConfig: scorecardConfig,
          ...get(subScore, 'scorecardScore', {}),
          ...subScore,
        });
      } else {
        setTag();
      }
    }
  }, [d, scorecard]);

  const showRowImages = (image.src || image.icon) && !expanded;

  return (
    <ListItem disableRipple={!!modalOpen} key={task.id} component={Link} to={`/tasks/detail/${task.id}?tcid=${tcid}`} button alignItems={'flex-start'} className={classes.ItemContainer}>
      <div className={classes.flexrow}>
        {renderIcon()}
        <ListItemText
          primary={
            <div className={classes.flexrow}>
              <div className={'Title'}>{task.name}</div>
            </div>
          }
          secondary={
            <>
              <div className={classes.textRow}>{get(task, 'description') || ''}</div>
              <div className="daterow">{`${get(task, 'authors.0.name')} - ${moment(task.createdAt).fromNow()}`}</div>
              <div className="daterow">
                <span style={{ fontWeight: 'bold' }}>{`${uppercaseFirst(status.title)}`}</span>
                {commText ? ` - ${commText}` : ''}
              </div>
            </>
          }
        />
        {showRowImages && (
          <ListItemSecondaryAction>
            <div>
              {image.src && <Image src={image.src} style={{ width: 70 }} />}
              {image.icon && <Icon classes={{ root: classes.imageIcon }}>{image.icon}</Icon>}
            </div>
          </ListItemSecondaryAction>
        )}
      </div>
      {expanded && (
        <div class={clsx(classes.expandContainer, !tag && classes.pad)}>
          {tag && (
            <div className={classes.tagContainer}>
              <RenderTag tag={tag} />
            </div>
          )}
          <div className={classes.imageRow}>
            <ImageList images={item.images} onOpen={() => setModalOpen(true)} onClose={() => setModalOpen(false)} spaceBetween={5} />
          </div>
        </div>
      )}
    </ListItem>
  );
};

export default realmChange(({ match }) => {
  const classes = useStyles();
  const [showCreate, setShowCreate] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const filter = useSelector((state) => get(state, 'filter.tasks.realm'));
  const newTasks = useSelector((state) => get(state, 'view.task.new'));
  const [showMessages, setShowMessages] = useState(false);
  const dispatch = useDispatch();
  const vendors = useVendors(undefined, { includeUsersRealm: true, include: 'vendor' });

  const { isMobile } = useScreen();

  const id = get(match, 'params.id', 0);

  const [messageParams, setMessageParams] = useState({ waitFor: null });
  const [urlParams, setUrlParams] = useState({ waitFor: null });

  const taskCountItem = useRetrieveData(
    { url: `/processed-task-count-values/${id}` },
    { build: ['processedTaskCountValues'], transformData: (d) => get(d, 0), params: { include: 'realm,realm.parent' } }
  );
  const item = get(taskCountItem, 'data');
  const loca = useLocation();
  const { realmId } = getUrlParams(loca.search);
  const _realmId = get(item, 'realm.id') || realmId;
  const isMy = get(filter, 'ownership') === 'my';

  const filterProps = (type) => {
    if (type === 'message') {
      return {
        include: 'realm,from,model,media,users',
        ...{ page: { size: pageSize, number: 1 } },
        ...buildFilters(
          {
            ...filter,
            realm: _realmId,
            _sort: {
              sortBy: '-created_at',
            },
          },
          {
            includeRealm: false,
            dontFilter: ['name', 'content', 'searchstring', 'ownership', 'status', 'vendor_id', 'age'],
            dontSort: ['-open', '-pending', 'updated_at', 'oldest', 'count'],
          }
        ),
      };
    } else {
      return {
        include,
        ...{ page: isMy ? undefined : { size: pageSize, number: 1 } },
        ...buildFilters(filter, {
          includeRealm: false,
          convertName: { searchstring: 'name', realm_type: 'tier' },
          dontFilter: ['content', 'name'],
          overrideFilter: (filtObj) => {
            if (filtObj.status) {
              set(filtObj, filtObj.status, true);
              delete filtObj.status;
            }
            if (filtObj.vendor_id === 0) {
              delete filtObj.vendor_id;
            }
            set(filtObj, 'onlyRealm', _realmId);
            return filtObj;
          },
          overrideSort: (sort) => {
            return undefined;
          },
        }),
      };
    }
  };

  useEffect(() => {
    if (!_realmId) {
      return;
    }

    setMessageParams({
      build: ['messages'],
      useEffect: true,
      waitFor: showMessages,
      params: filterProps('message'),
    });
    setUrlParams({
      build: ['tasks'],
      useEffect: true,
      waitFor: undefined,
      params: filterProps(),
    });
  }, [filter, _realmId, showMessages]);

  const { data, loading, update, meta } = useRetrieveData({ url: `/tasks` }, urlParams);
  const messages = useRetrieveData({ url: '/messages' }, messageParams);

  useEffect(() => {
    if (taskCountItem.loading) {
      return;
    }

    messages.update();
  }, [newTasks]);

  useEffect(() => {
    dispatch(setTaskList(data));
  }, [data]);

  const toggleMessages = async () => {
    setShowMessages(!showMessages);
  };

  const lastPageMessages = get(messages.meta, 'page.last-page', null);
  const lastPageTasks = get(meta, 'page.last-page', null);
  const updatePage = (newPage, params) => {
    if (params === 'messages') {
      if (newPage <= lastPageMessages) {
        setMessageParams({
          ...messageParams,
          params: {
            ...messageParams.params,
            page: { size: pageSize, number: newPage },
          },
        });
      }
    } else if (params === 'tasks') {
      if (newPage <= lastPageTasks) {
        setUrlParams({
          ...urlParams,
          params: {
            ...urlParams.params,
            page: { size: pageSize, number: newPage },
          },
        });
      }
    }
  };

  const getItemOverride = () => {
    const obj = {
      ...item,
      open: 0,
      pending: 0,
      closed: 0,
    };

    if (loading) {
      obj.open = Loading;
      obj.pending = Loading;
      obj.closed = Loading;
    } else {
      data.map((di) => {
        if (di.status === 0) {
          obj.open += 1;
        } else if (di.status === 1) {
          obj.pending += 1;
        } else if (di.status === 2) {
          obj.closed += 1;
        }
      });
    }

    return obj;
  };

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <TaskFilters display={'realm'} vendors={vendors} />
      </LeftSideBar>

      <CenterContent overflowHidden={true}>
        <TaskNotify realmId={_realmId} />
        {isMobile && (
          <div className={classes.padRow}>
            <TaskFilters display={'realm'} vendors={vendors} />
          </div>
        )}
        {item && (
          <List className={classes.noPadding}>
            <TaskListItem destination={`/tasks/list`} item={taskCountItem.data} itemOverride={isMy && getItemOverride()} isHeader={true} />
            <div className={classes.padLeft}>
              <Button
                disabled={!userHasPermissions('createTasks')}
                className={classes.button}
                variant="contained"
                color="secondary"
                onClick={() => setShowCreate(true)}
                startIcon={<Icon>add_a_photo</Icon>}
              >
                ADD NEW
              </Button>
              <Button className={classes.button} variant="contained" disableElevation color="primary" onClick={toggleMessages} startIcon={<Icon>{showMessages ? 'close' : 'mail'}</Icon>}>
                {'PDFS'}
              </Button>
              <Button className={classes.expandButton} variant="contained" disableElevation color="primary" onClick={() => setExpanded(!expanded)}>
                {expanded ? <CondenseIcon /> : <Icon>expand</Icon>}{' '}
              </Button>
            </div>
          </List>
        )}

        {showMessages && (
          <MessagesList
            handlePageChange={(np) => updatePage(np, 'messages')}
            currentPage={get(messageParams, 'params.page.number', 1)}
            lastPage={lastPageMessages}
            data={messages.data || []}
            loading={messages.loading}
            header={null}
          />
        )}

        {!showMessages && (
          <TaskList
            handlePageChange={(np) => updatePage(np, 'tasks')}
            currentPage={get(urlParams, 'params.page.number', 1)}
            lastPage={lastPageTasks}
            data={data || []}
            loading={loading}
            trackChecks={newTasks}
            expanded={expanded}
            tcid={id}
          />
        )}

        {showCreate && (
          <TaskCreate
            open={showCreate}
            onClose={() => {
              update();
              setShowCreate(false);
            }}
            realmItem={{
              realmName: get(item, 'realmName', ''),
              realm: {
                id: _realmId,
              },
            }}
          />
        )}
      </CenterContent>
      <RightSideBar />
    </GridContainer>
  );
});

const MessagesList = withInfiniteScroll(MessageListItem, List);
const TaskList = withInfiniteScroll(TaskItem, List);
